import { css } from "@emotion/react";

export const tooltipSvg = css`
  width: 100%;
`;
